module.exports = __webpack_public_path__ + "static/media/majetok2.1cabc7ff.png";